
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.5 2.5h2v1.406a5.62 5.62 0 012.25.938l.938-.938 1.406 1.406-.938.938c.464.664.792 1.421.938 2.25H29.5v2h-1.406a5.625 5.625 0 01-.938 2.281l.969 1.031-1.469 1.375-.938-1a5.617 5.617 0 01-2.219.906v1.406h-2v-1.406a5.62 5.62 0 01-2.25-.938l-1.031 1.063-1.438-1.438 1.063-1.031a5.615 5.615 0 01-.938-2.25h-1.406v-2h1.406a5.632 5.632 0 01.906-2.219l-1-.938 1.375-1.469 1.031.969a5.665 5.665 0 012.281-.938V2.498zm1 3.313c-2.055 0-3.688 1.632-3.688 3.688s1.632 3.688 3.688 3.688 3.688-1.632 3.688-3.688-1.632-3.688-3.688-3.688zM9.531 11.719l.719 1.813a6.865 6.865 0 011.656-.219c.571 0 1.126.085 1.656.219l.719-1.813 1.844.75-.719 1.813a6.887 6.887 0 012.313 2.313l1.813-.719.75 1.844-1.813.719c.132.529.219 1.087.219 1.656s-.086 1.126-.219 1.656l1.813.719-.75 1.844-1.813-.719a6.907 6.907 0 01-2.313 2.344l.719 1.781-1.844.75-.719-1.781a6.76 6.76 0 01-1.656.219 6.713 6.713 0 01-1.656-.219l-.719 1.781-1.844-.75.719-1.781a6.873 6.873 0 01-2.344-2.344l-1.781.719-.75-1.844 1.781-.719c-.134-.53-.219-1.087-.219-1.656s.085-1.128.219-1.656l-1.781-.719.75-1.844 1.781.719a6.916 6.916 0 012.344-2.313l-.719-1.813zm2.375 3.594c-2.663 0-4.813 2.118-4.813 4.781s2.15 4.813 4.813 4.813 4.781-2.15 4.781-4.813-2.118-4.781-4.781-4.781z"}})])
          )
        }
      }
    